(function() {
  const BASE_DOMAIN = 'brain-effect.com';
  const CONTENT_SELECTORS = '.article-template #MainContent, .index-template #MainContent, .page-template #MainContent';
  const MARKET_LANG_DIRS = ['fr-fr', 'de-fr', 'en-eu', 'fr-eu', 'de-eu', 'en', 'fr']; // keep compound prefixes before short ones
  function getUserMarketLangDir() {
    try {
      if (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url) {
        const prefix = window.FoxTheme.routes.root_url.replace(/^\/|\/$/g, '');
        if (MARKET_LANG_DIRS.indexOf(prefix) !== -1) return prefix;
        if (prefix === '') return '';
      }
      return '';
    } catch (e) {
      return '';
    }
  }

  function addPrefix(path, prefix) {
    const clean = removeLocalePrefix(path);
    return prefix ? '/' + prefix + clean : clean;
  }

  function removeLocalePrefix(pathname) {
    const clean = pathname.charAt(0) === '/' ? pathname.slice(1) : pathname;
    for (let i = 0; i < MARKET_LANG_DIRS.length; i++) {
      const prefix = MARKET_LANG_DIRS[i];
      if (clean === prefix || clean.indexOf(prefix + '/') === 0) {
        const rest = clean.slice(prefix.length);
        return rest.charAt(0) === '/' ? rest : '/' + rest;
      }
    }
    return pathname;
  }

  function processLinks() {
    const currentPrefix = getUserMarketLangDir();
    const containers = document.querySelectorAll(CONTENT_SELECTORS);
    if (!containers.length) return;

    containers.forEach(function(container) {
      container.querySelectorAll('a[href]').forEach(function(link) {
        const href = link.getAttribute('href');
        let url;
        try { url = new URL(href); } catch (e) { return; }
        let hostname = url.hostname;
        if (hostname.indexOf('www.') === 0) hostname = hostname.slice(4);
        if (hostname !== BASE_DOMAIN) return;
        url.hostname = BASE_DOMAIN;
        url.pathname = addPrefix(url.pathname, currentPrefix);
        const hasCountry = url.searchParams.has('country');
        const redirect = url.searchParams.get('redirect');
        let newRedirect = null;
        if (redirect && redirect.charAt(0) === '/') {
          const localized = addPrefix(redirect, currentPrefix);
          if (localized !== redirect) newRedirect = localized;
        }
        if (hasCountry || newRedirect !== null) {
          url.searchParams.delete('country');
          if (newRedirect !== null) url.searchParams.set('redirect', newRedirect);
        }
        let newHref = url.toString();
        if (newHref.endsWith('/') && !href.endsWith('/') && url.pathname === '/') {
          newHref = newHref.slice(0, -1);
        }
        if (newHref !== href) {
          link.setAttribute('href', newHref);
        }
      });
    });
  }

  if (window.Shopify?.designMode) return;
  processLinks();
})();
